module.exports = __webpack_public_path__ + "static/media/pin_users.c2066e49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_users.svg
// module id = 901
// module chunks = 0